import { render, staticRenderFns } from "./vcModalAnulated.vue?vue&type=template&id=20504f98&scoped=true&"
import script from "./vcModalAnulated.vue?vue&type=script&lang=js&"
export * from "./vcModalAnulated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20504f98",
  null
  
)

export default component.exports